class ClientHelp extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.businessHoursStartTime = this.dataset.start
    this.businessHoursEndTime = this.dataset.end
    this.checkBusinessHours = this.checkBusinessHours.bind(this)
    this.checkTheme = this.checkTheme.bind(this)

    this.checkBusinessHours()
    this.checkTheme()
    setInterval(this.checkBusinessHours, 6000)

    if (this.dataset.template !== 'product') return

    this.isTicking = false

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    this.externalEls?.chat?.elements.forEach((chatEl) => {
      chatEl.addEventListener('click', this.handleClick.bind(this))
    })

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0]

      this.classList.toggle('sec-ClientHelp-hidden', entry.isIntersecting)
    })

    observer.observe(this.externalEls?.footer?.element)

    if (this.dataset.template !== 'product') return

    this.onScroll = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  checkTheme () {
    const theme = document.body.dataset.theme

    if (theme !== '') {
      this.classList.add(`col-Theme_${theme === 'light' ? 'Dark' : 'Light'}`)
    }
  }

  checkBusinessHours (e) {
    const now = new Date().toLocaleString('sv-SE', {
      timeZone: 'Europe/Stockholm',
    })
    const time = new Date(now)
    const startBusinessHour = new Date(time)
    const endBusinessHour = new Date(time)

    startBusinessHour.setHours(this.businessHoursStartTime, 0, 0)
    endBusinessHour.setHours(this.businessHoursEndTime, 0, 0)

    this.isWithinBusinessHours =
      time >= startBusinessHour && time <= endBusinessHour

    if (this.isWithinBusinessHours) {
      this.externalEls.body.element.classList.add('sec-ClientHelp_Body-active')
      this.classList.add('sec-ClientHelp-active')
    } else {
      this.externalEls.body.element.classList.remove(
        'sec-ClientHelp_Body-active',
      )
      this.classList.remove('sec-ClientHelp-active')
    }
  }

  handleClick () {
    window.zE('messenger', 'open')

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'client_service_chat_started',
    })
  }

  onScroll () {
    if (window.BAO.MediaBreakpoints.isMd) return

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.handleScroll()
  }

  handleScroll () {
    const externalButtonEl = document.querySelector(
      '[data-client-help-external-el="button"]',
    )

    if (!externalButtonEl) return

    const triggerPosition =
      externalButtonEl.offsetTop +
      externalButtonEl.offsetHeight -
      (window.innerHeight - 10)

    this.classList.toggle(
      'sec-ClientHelp-offset',
      window.scrollY < triggerPosition,
    )
  }
}

if (!customElements.get('client-help')) {
  customElements.define('client-help', ClientHelp)
}
